const MlseLogo = () => {
  return (
    <svg
      width="49"
      height="10"
      viewBox="0 0 49 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3009_22720)">
        <rect width="49" height="10" fill="#3E4784" />
        <path
          d="M0 9.64014V0.140137H5L7.5 5.64014L10 0.140137H14.5V9.64014H11.5V3.14014L8.5 9.64014H6L3 3.14014V9.64014H0Z"
          fill="#FCFCFD"
          stroke="#FCFCFD"
          strokeWidth="0.5"
        />
        <path
          d="M16.5 9.64014V0.140137H19.5V7.14014H25.5V9.64014H16.5Z"
          fill="#FCFCFD"
          stroke="#FCFCFD"
          strokeWidth="0.5"
        />
        <path
          d="M39.5 9.64014V0.140137H49V2.14014H42.5V3.64014H47.5V5.64014H42.5V7.14014H49V9.64014H39.5Z"
          fill="#FCFCFD"
          stroke="#FCFCFD"
          strokeWidth="0.5"
        />
        <path
          d="M36.5 3.14018L37.5 1.14018C33.7494 -0.400162 29.5 -0.359824 28 1.14018C26.5 2.64018 27 4.64018 28 5.14018C29 5.64018 34 6.14018 34.5 6.64018C34.7832 6.89089 34.783 7.00034 34.5 7.14018C31.7663 8.12286 30.2336 7.47408 27.5 6.64018L26.5 8.64018C31.8399 10.2609 34.2728 10.3478 37 8.14018C38.016 6.74626 37.9579 5.52638 36.5 4.64018C35.0421 3.75398 30.6035 3.2437 30.5 3.14018C30.3965 3.03667 30.3144 2.82574 30.5 2.64018C30.6856 2.45463 33.8597 1.93902 36.5 3.14018Z"
          fill="#FCFCFD"
          stroke="#FCFCFD"
          strokeWidth="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_3009_22720">
          <rect width="49" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MlseLogo;
